export default __webpack_public_path__ + "static/media/icon-checkmark-black.d62ddc6f.svg";